import React from 'react';
import './variables-panel.css';

const statusIcon = {
  ok: '✔️',
  undefined: '⚠️',
  duplicate: '❗',
  unused: 'ℹ️'
};

export default function VariableRow({ rec, onJump }) {
  const primaryTarget = rec.definedAt[0] || rec.usedAt[0];
  return (
    <tr className={`var-row ${rec.status}`}>
      <td>
        {statusIcon[rec.status]}{' '}
        {primaryTarget ? (
          <span className="node-link" onClick={() => onJump(primaryTarget)}>{rec.name}</span>
        ) : (
          rec.name
        )}
      </td>
      <td>{rec.definedAt.length ? rec.definedAt.map(id => link(id)).reduce(sep, []) : '—'}</td>
      <td>{rec.usedAt.length ? rec.usedAt.map(id => link(id)).reduce(sep, []) : '—'}</td>
      <td>{rec.actualValue ?? '—'}</td>
    </tr>
  );

  function link(id) {
    return <span key={id} className="node-link" onClick={() => onJump(id)}>{id}</span>;
  }
  function sep(acc, curr) {
    return acc.length ? [...acc, ', ', curr] : [curr];
  }
}
